type ReferenceIdentifierLike = {
  openalex_id?: string | null;
  doc_id?: string | null;
  link?: string | null;
};

function normalizeOpenAlexId(value: string) {
  return value.trim().replace(/^https?:\/\/openalex\.org\//i, '');
}

export function getOpenAlexId(reference: ReferenceIdentifierLike) {
  const explicitId = reference.openalex_id?.trim();
  if (explicitId) return normalizeOpenAlexId(explicitId);

  const docId = reference.doc_id?.trim();
  if (docId?.toLowerCase().startsWith('openalex|')) {
    return normalizeOpenAlexId(docId.slice('openalex|'.length));
  }

  const match = reference.link?.match(/openalex\.org\/([^/?#]+)/i);
  return match?.[1] ? normalizeOpenAlexId(match[1]) : '';
}
